export default __webpack_public_path__ + "static/media/sari (7).16a9176e.jpeg";